<template>
  <div class="elevation-1 container" style="margin-bottom: 16px;">
    <v-textarea label="Source" :rows="1" v-model.trim="value.text"></v-textarea>
    <v-textarea label="Translation" :rows="1" v-model.trim="value.translatedText"></v-textarea>
    <p v-if="hint">
      You can use translation <a href="#" @click.prevent="useHint(hint)">"{{ hint }}"</a>
    </p>
    <div class="text-xs-right">
      <v-btn @click="$emit('remove', value)">Remove</v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { TranslatorApi } from '../common/api'
import { actual } from '../util'
import debounce from 'lodash/debounce'

const translate = actual(TranslatorApi.translate)

export default {
  props: ['value'],
  data () {
    return {
      hint: null
    }
  },
  computed: {
    sourceLanguage () {
      return this.dictionary.sourceLanguage || {}
    },
    targetLanguage () {
      return this.dictionary.targetLanguage || {}
    },
    ...mapState([
      'dictionary'
    ])
  },
  watch: {
    'value.text' (val) {
      if (!val) {
        return
      }

      this.debouncedTranslateHint()
    }
  },
  created () {
    this.debouncedTranslateHint = debounce(this.translateHint, 300)
    if (this.value && this.value.text) {
      this.debouncedTranslateHint()
    }
  },
  methods: {
    useHint (hint) {
      this.value.translatedText = hint
    },
    async translateHint () {
      try {
        this.hint = null
        const { data } = await translate(() => [this.value.text, this.sourceLanguage.id, this.targetLanguage.id])
        this.hint = data.text
      } catch (e) {
        alert(e)
      }
    }
  }
}
</script>
